import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Documents\DocumentAttachmentsController::store
* @see app/Http/Controllers/Documents/DocumentAttachmentsController.php:31
* @route '/works/{work}/documents'
*/
export const store = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/works/{work}/documents',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Documents\DocumentAttachmentsController::store
* @see app/Http/Controllers/Documents/DocumentAttachmentsController.php:31
* @route '/works/{work}/documents'
*/
store.url = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { work: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { work: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            work: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
    }

    return store.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Documents\DocumentAttachmentsController::store
* @see app/Http/Controllers/Documents/DocumentAttachmentsController.php:31
* @route '/works/{work}/documents'
*/
store.post = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Documents\DocumentAttachmentsController::store
* @see app/Http/Controllers/Documents/DocumentAttachmentsController.php:31
* @route '/works/{work}/documents'
*/
const storeForm = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Documents\DocumentAttachmentsController::store
* @see app/Http/Controllers/Documents/DocumentAttachmentsController.php:31
* @route '/works/{work}/documents'
*/
storeForm.post = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Documents\DocumentAttachmentsController::show
* @see app/Http/Controllers/Documents/DocumentAttachmentsController.php:56
* @route '/works/{work}/documents/{document}'
*/
export const show = (args: { work: string | { slug: string }, document: string | number | { id: string | number } } | [work: string | { slug: string }, document: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/works/{work}/documents/{document}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Documents\DocumentAttachmentsController::show
* @see app/Http/Controllers/Documents/DocumentAttachmentsController.php:56
* @route '/works/{work}/documents/{document}'
*/
show.url = (args: { work: string | { slug: string }, document: string | number | { id: string | number } } | [work: string | { slug: string }, document: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            work: args[0],
            document: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
        document: typeof args.document === 'object'
        ? args.document.id
        : args.document,
    }

    return show.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace('{document}', parsedArgs.document.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Documents\DocumentAttachmentsController::show
* @see app/Http/Controllers/Documents/DocumentAttachmentsController.php:56
* @route '/works/{work}/documents/{document}'
*/
show.get = (args: { work: string | { slug: string }, document: string | number | { id: string | number } } | [work: string | { slug: string }, document: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Documents\DocumentAttachmentsController::show
* @see app/Http/Controllers/Documents/DocumentAttachmentsController.php:56
* @route '/works/{work}/documents/{document}'
*/
show.head = (args: { work: string | { slug: string }, document: string | number | { id: string | number } } | [work: string | { slug: string }, document: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Documents\DocumentAttachmentsController::show
* @see app/Http/Controllers/Documents/DocumentAttachmentsController.php:56
* @route '/works/{work}/documents/{document}'
*/
const showForm = (args: { work: string | { slug: string }, document: string | number | { id: string | number } } | [work: string | { slug: string }, document: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Documents\DocumentAttachmentsController::show
* @see app/Http/Controllers/Documents/DocumentAttachmentsController.php:56
* @route '/works/{work}/documents/{document}'
*/
showForm.get = (args: { work: string | { slug: string }, document: string | number | { id: string | number } } | [work: string | { slug: string }, document: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Documents\DocumentAttachmentsController::show
* @see app/Http/Controllers/Documents/DocumentAttachmentsController.php:56
* @route '/works/{work}/documents/{document}'
*/
showForm.head = (args: { work: string | { slug: string }, document: string | number | { id: string | number } } | [work: string | { slug: string }, document: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Documents\DocumentAttachmentsController::destroy
* @see app/Http/Controllers/Documents/DocumentAttachmentsController.php:74
* @route '/works/{work}/documents/{document}'
*/
export const destroy = (args: { work: string | { slug: string }, document: string | number | { id: string | number } } | [work: string | { slug: string }, document: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/works/{work}/documents/{document}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Documents\DocumentAttachmentsController::destroy
* @see app/Http/Controllers/Documents/DocumentAttachmentsController.php:74
* @route '/works/{work}/documents/{document}'
*/
destroy.url = (args: { work: string | { slug: string }, document: string | number | { id: string | number } } | [work: string | { slug: string }, document: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            work: args[0],
            document: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
        document: typeof args.document === 'object'
        ? args.document.id
        : args.document,
    }

    return destroy.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace('{document}', parsedArgs.document.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Documents\DocumentAttachmentsController::destroy
* @see app/Http/Controllers/Documents/DocumentAttachmentsController.php:74
* @route '/works/{work}/documents/{document}'
*/
destroy.delete = (args: { work: string | { slug: string }, document: string | number | { id: string | number } } | [work: string | { slug: string }, document: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Documents\DocumentAttachmentsController::destroy
* @see app/Http/Controllers/Documents/DocumentAttachmentsController.php:74
* @route '/works/{work}/documents/{document}'
*/
const destroyForm = (args: { work: string | { slug: string }, document: string | number | { id: string | number } } | [work: string | { slug: string }, document: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Documents\DocumentAttachmentsController::destroy
* @see app/Http/Controllers/Documents/DocumentAttachmentsController.php:74
* @route '/works/{work}/documents/{document}'
*/
destroyForm.delete = (args: { work: string | { slug: string }, document: string | number | { id: string | number } } | [work: string | { slug: string }, document: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const documents = {
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    destroy: Object.assign(destroy, destroy),
}

export default documents